import React, { Component } from "react";
import "./HeaderCard.css";

class HeaderCard extends Component {
  render() {
    var headerClass = this.props.headerClass + " header-card";
    return (
      <div className={headerClass}>
        <h5 className="header-label">{this.props.headerLabel}</h5>
        <h4 className="header-value">{this.props.headerValue}</h4>
      </div>
    );
  }
}

export default HeaderCard;
